import { useEffect, useState } from 'preact/hooks';
import { useI18n } from '../hooks/use-i18n';
import { widgetClientId } from '../store/widget-store';
import { shouldShowDragHint, markDragHintShown } from '../services/widget-position-store';

/** 提示自动消失时长(ms) */
const AUTO_DISMISS_MS = 4000;

/**
 * 迷你按钮「长按可拖动」提示气泡 —— 作为按钮的绝对定位子元素(随按钮移动)。
 * 挂载时按 shouldShowDragHint 决定是否首显(用户拖过 / 1h 内已提示过 → 不显),
 * 首显即写冷却时间戳;AUTO_DISMISS_MS 后或一旦开始拖动(dragging=true)即隐藏。
 */
export function DragHint({ dragging }: { dragging: boolean }) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (shouldShowDragHint(widgetClientId.value, Date.now())) {
      markDragHintShown(widgetClientId.value, Date.now());
      setVisible(true);
      const id = window.setTimeout(() => setVisible(false), AUTO_DISMISS_MS);
      return () => clearTimeout(id);
    }
    return undefined;
  }, []);

  useEffect(() => {
    if (dragging) setVisible(false);
  }, [dragging]);

  if (!visible) return null;
  return (
    <span class="dcs-drag-hint" aria-hidden="true">
      {t('bubble.dragHint')}
    </span>
  );
}
